import React, { useState, useEffect, useMemo } from "react";
import api from "../api/api";
import { Container, Row, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Modal, Form } from "react-bootstrap";
import swal from "sweetalert";
import { Tabs, Tab } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import SettingsIcon from "@mui/icons-material/Settings";
import { Chip } from "@mui/material";

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import HistoryIcon from "@mui/icons-material/History";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SmsIcon from "@mui/icons-material/Sms";
import CalculateIcon from "@mui/icons-material/Calculate";
import { Box, Button, IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { DataGrid } from "@mui/x-data-grid";
import "./AdminManagement.css";

import DownloadIcon from "@mui/icons-material/Download";

import AddIcon from "@mui/icons-material/Add";
import Pagination from "../views/Pagination";
import { useNavigate } from "react-router";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import Swal from "sweetalert2";

const calculationStatusMeta = {
  CALCULATION_SUCCEEDED: { labelKey: "calc_status_succeeded", color: "success" },
  CALCULATION_OUTDATED: { labelKey: "calc_status_outdated", color: "warning" },
  READY: { labelKey: "calc_status_ready", color: "info" },
  NEVER_CALCULATED: { labelKey: "calc_status_never_calculated", color: "default" },
  CONFIGURATION_REQUIRED: { labelKey: "calc_status_config_required", color: "warning" },
  CALCULATION_FAILED: { labelKey: "calc_status_failed", color: "error" },
};

const calculationReasonKeys = {
  NO_ACTIVE_SEASON: "calc_reason_no_active_season",
  MULTIPLE_ACTIVE_SEASONS: "calc_reason_multiple_active_seasons",
  SEASON_START_MISSING_OR_INVALID: "calc_reason_season_start_invalid",
  SEASON_START_IN_FUTURE: "calc_reason_season_not_started",
  SEASON_ALREADY_ENDED: "calc_reason_season_ended",
  CROP_DURATION_INVALID: "calc_reason_crop_duration_invalid",
  KC_DATA_MISSING: "calc_reason_kc_missing",
  KC_DATA_INVALID: "calc_reason_kc_invalid",
  KC_DATA_TOO_SHORT: "calc_reason_kc_too_short",
  SOIL_RUMAX_MISSING: "calc_reason_soil_rumax_missing",
  FIELD_LOCATION_MISSING: "calc_reason_field_location_missing",
  IRRIGATION_CONFIGURATION_MISSING: "calc_reason_irrigation_config_missing",
  IRRIGATED_AREA_MISSING: "calc_reason_irrigated_area_missing",
  WEATHER_DATA_MISSING: "calc_reason_weather_missing",
  CALCULATION_OUTDATED: "calc_reason_calculation_outdated",
};

const kcSourceKeys = {
  crop: "kc_source_crop",
  variety: "kc_source_variety",
  crop_type: "kc_source_crop_type",
};

const getKcStatusMessage = (row, t) => {
  if (row.calculationKcStatus === "VALID") {
    const source = t(kcSourceKeys[row.calculationKcSource] || row.calculationKcSource, row.calculationKcSource);
    return t("kc_valid_source_days", {
      source,
      days: row.calculationKcLength,
      defaultValue: `Kc valides — source : ${source} — ${row.calculationKcLength} jours`,
    });
  }
  if (row.calculationKcStatus === "TOO_SHORT") {
    return t("kc_too_short_days", {
      length: row.calculationKcLength,
      required: row.calculationKcRequiredDays,
      defaultValue: `Courbe Kc trop courte : ${row.calculationKcLength}/${row.calculationKcRequiredDays} jours`,
    });
  }
  if (row.calculationKcStatus === "INVALID") {
    return t("calc_reason_kc_invalid");
  }
  return t("kc_no_curve_available", "Aucune courbe Kc disponible");
};

const FieldsManagement = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [fields, setFields] = useState([]);
  const [users, setUsers] = useState([]);
  const [singleField, setSingleField] = useState({});
  const [reports, setReports] = useState([]);
  const [show, setShow] = useState(false);
  const [showRecomnd, setShowRecomnd] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [isGeneratingCalcul, setIsGeneratingCalcul] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  const [calculData, setCalculData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [farmFilter, setFarmFilter] = useState("");
  const [cropFilter, setCropFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [selectionModel, setSelectionModel] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportGenerationResults, setReportGenerationResults] = useState({
    success: [],
    failure: [],
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedField, setSelectedField] = useState(null);
  const [autoCalcul, setAutoCalcul] = useState(null);
  const [autoRapport, setAutoRapport] = useState(null);
  const [saving, setSaving] = useState(false);
  const [refreshFields, setRefreshFields] = useState(false);
  const [autoSatellite, setAutoSatellite] = useState(null);

  const getSelectedFieldIds = () => {
    if (selectionModel?.ids) return Array.from(selectionModel.ids);
    return Array.isArray(selectionModel) ? selectionModel : [];
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowRecomnd = () => setShowRecomnd(true);
  const handleCloseRecomnd = () => setShowRecomnd(false);

  const getFields = async () => {
    setLoading(true);
    try {
      const response = await api("/admin/fields");
      let fieldsData = response.data.fields;
      let usersData = response.data.users;

      setFields(fieldsData);
      setUsers(usersData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const generateReport = async () => {
    const fieldIdsArray = getSelectedFieldIds();
    if (!fieldIdsArray.length) return;

    setIsGeneratingReport(true);

    try {
      const response = await api.post(
        "/pdf/createMultiplePdfs",
        { fieldIds: fieldIdsArray },
        { timeout: 0 }
      );

      const results = response.data.results;

      const success = [];
      const failure = [];

      results.forEach((r) => {
        const fieldName = r.name || t("unknown");

        if (r.success) {
          success.push({
            fieldName,
            status: t("success_status"),
            file: r.file,
          });

          if (r.file) {
            window.open(`${process.env.REACT_APP_BASE_URL}/${r.file}`, "_blank");
          }
        } else {
          failure.push({
            fieldName,
            status: t("failed_status"),
            reason: r.message || r.error || t("error_generating_report"),
            details: r.details || [],
          });
        }
      });

      setReportGenerationResults({ success, failure });
      setReportModalOpen(true);
    } catch (error) {
      console.error("Erreur lors de la génération :", error);
      swal({
        icon: "error",
        text: t("server_error_generating_reports"),
      });
    } finally {
      setIsGeneratingReport(false);
    }
  };

  const handleCloseReportModal = () => {
    setReportModalOpen(false);
    setReportGenerationResults({ success: [], failure: [] });
  };

  const handleGenerateCalcul = async () => {
    setIsGeneratingCalcul(true);
    setResult(null);
    const fieldIdsArray = getSelectedFieldIds();

    try {
      const response = await api.post("/admin/fields-sensor-calcul", {
        fieldIds: fieldIdsArray,
      });

      setResult(response.data);
      setOpenModal(true);
    } catch (err) {
      console.error("Error generating calculs:", err);
      swal({
        icon: "error",
        text: t("error_generating_calculs"),
      });
    } finally {
      setIsGeneratingCalcul(false);
    }
  };

  const getSingleField = async (fieldId) => {
    await api
      .post("/admin/fields/single-field", { fieldId })
      .then((response) => {
        if (response.data.type === "success") {
          let fieldData = response.data.field;
          setSingleField(fieldData);
          let allReports = fieldData.reports;
          setReports(allReports);
          handleShow(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [recommendations, setRecmnd] = useState([]);
  const [message, setMessage] = useState("");
  const [userId, setUserId] = useState("");
  const getSingleFieldRecmnds = async (fieldId, userId) => {
    await api
      .get(`/recommendations/${userId}/${fieldId}`)
      .then((response) => {
        const fieldRecommendations = response.data.recommendations || [];
        setRecmnd(fieldRecommendations);
        setMessage(fieldRecommendations[0]?.message || "");
        setUserId(fieldRecommendations[0]?.user_id || userId);
        handleShowRecomnd(true);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleViewReport = async (uid, fieldId) => {
    try {
      const response = await api.get(`/calcul/field-calcul/${uid}`);
      const data = response.data.calcul;

      if (Array.isArray(data) && data.length > 0) {
        navigate(`/rapport-hebdomadaire/${uid}`);
      } else if (
        data?.type === "danger" &&
        data?.message === "no_field_calcul"
      ) {
        setWarningMessage(t("no_calcul_for_week"));
        setTimeout(() => setWarningMessage(""), 5000);
      } else {
        setWarningMessage(t("no_calcul_data"));
        setTimeout(() => setWarningMessage(""), 5000);
      }
    } catch (error) {
      if (
        error.response?.data?.type === "danger" &&
        error.response?.data?.message === "no_field_calcul"
      ) {
        setWarningMessage(t("no_calcul_for_week"));
        setTimeout(() => setWarningMessage(""), 5000);
      } else {
        console.error("Erreur lors de la vérification du calcul:", error);
        setWarningMessage(t("error_checking_calcul"));
        setTimeout(() => setWarningMessage(""), 5000);
      }
    }
  };

  const calculSimulation = async (fieldId, userId) => {
    try {
      const response = await api.post("/admin/field-sensor-calcul", {
        fieldId,
        userId,
      });
      const data = await response.data.data;
      const feedback = response.data.feedback || [];
      if (data && data.length > 0) {
        navigate(`/admin/calcul-fields/${fieldId}`, {
          state: {
            calculData: data,
          },
        });
      } else {
        if (feedback.length > 0) {
          const reasons = feedback.flatMap((f) => f.reasons || []);
          const uniqueReasons = [...new Set(reasons)]
            .map((reason) => calculationReasonLabels[reason] || reason);

          await Swal.fire({
            icon: "info",
            title: t("no_simulation_performed"),
            text: `${t("possible_reasons")} : ${uniqueReasons.join(" • ")}`,
          });
        } else {
          await Swal.fire({
            icon: "info",
            title: t("no_simulation_performed"),
            text: t("no_valid_data_for_field"),
          });
        }

        setCalculData([]);
      }
    } catch (error) {
      console.error(error);
      await Swal.fire({
        icon: "error",
        title: t("error"),
        text: t("error_during_calcul"),
      });
    }
  };

  useEffect(() => {
    getFields();
  }, [refreshFields]);

  const handleClick = async (file) => {
    try {
      let data = { filename: file };
      const response = await api.post("/report/download", data, { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "historique.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      swal({ icon: "error", text: t("error_downloading_report") });
    }
  };

  const goToField = (uid, userId) => {
    if (uid) {
      localStorage.setItem("Field", uid);
    } else {
      localStorage.setItem("Field", 0);
    }
    navigate(`/Fields/${uid}`);
  };

  const goToHistory = (code) => {
    navigate(`/my-history/${code}`);
  };

  const getUserPhone = (userId) => {
    const user = users.find((user) => user.id === userId);
    return user ? user.phone_number : "-";
  };

  const sendSMSToUser = (phone) => {
    const data = {
      phoneNumber: phone,
      message: message,
    };

    try {
      if (message && message !== "") {
        api
          .post("/admin/send-sms", data)
          .then((response) => {
            if (response.data.type === "success") {
              swal({
                icon: "success",
                text: t("sms_sent_success"),
              });
            }
          })
          .catch((error) => {
            console.error(error);
            swal({
              icon: "error",
              text: t("error_sending_sms"),
            });
          });
      }
    } catch (error) {
      console.error(error);
      swal({
        icon: "error",
        text: t("error_sending_sms"),
      });
    }
  };

  const sendToUser = async (reportId, userId) => {
    try {
      const response = await api.post(`/admin/send-report-email`, {
        reportId,
        userId,
      });
      if (response.data.type === "success") {
        swal({
          icon: "success",
          text: t("report_sent_success"),
        });
      }
    } catch (error) {
      swal({
        icon: "error",
        text: t("error_sending_report"),
      });
    }
  };

  const fieldRows = useMemo(() => fields.map((field) => {
    const crops = field.crops || [];
    const crop = crops.find((item) => Number(item.season_active) === 1) || crops[crops.length - 1];
    const owner = field.farm?.user || {};
    const sensor = (field.sensors || []).find((item) => Number(item.synchronized) === 1)
      || (field.sensors || [])[field.sensors?.length - 1];

    return {
      id: field.id,
      uid: field.uid,
      userId: owner.id,
      userName: owner.name || t("unknown_user"),
      userEmail: owner.email || "",
      farmId: field.farm?.id || field.farm_id,
      farmName: field.farm?.name || "-",
      fieldName: field.name || "-",
      cropType: crop?.croptypes?.crop || t("no_crop", "Aucune culture"),
      cropVariety: crop?.varieties?.crop_variety || t("variety_not_specified", "Variété non renseignée"),
      sensorCode: sensor?.code || "-",
      autoCalcul: Boolean(field.auto_calcul),
      autoReport: Boolean(field.auto_rapport),
      calculationStatus: field.calculation_status || "NEVER_CALCULATED",
      calculationReasons: field.calculation_reasons || [],
      calculationWarnings: field.calculation_warnings || [],
      calculationKcSource: field.calculation_kc_source,
      calculationKcStatus: field.calculation_kc_status || "MISSING",
      calculationKcLength: Number(field.calculation_kc_length) || 0,
      calculationKcRequiredDays: Number(field.calculation_kc_required_days) || 0,
      lastCalculationAt: field.last_calculation_at,
    };
  }).sort((a, b) => a.userName.localeCompare(b.userName) || a.fieldName.localeCompare(b.fieldName)), [fields]);

  const filterOptions = useMemo(() => ({
    users: [...new Map(fieldRows.map((row) => [row.userId || row.userName, {
      value: String(row.userId || row.userName), label: row.userName,
    }])).values()].sort((a, b) => a.label.localeCompare(b.label)),
    farms: [...new Map(fieldRows.map((row) => [row.farmId || row.farmName, {
      value: String(row.farmId || row.farmName), label: row.farmName,
    }])).values()].sort((a, b) => a.label.localeCompare(b.label)),
    crops: [...new Set(fieldRows.map((row) => row.cropType))].sort(),
  }), [fieldRows]);

  const filteredRows = useMemo(() => {
    const query = searchTerm.trim().toLocaleLowerCase();
    return fieldRows.filter((row) => {
      const searchable = [row.userName, row.userEmail, row.farmName, row.fieldName,
        row.cropType, row.cropVariety, row.sensorCode].join(" ").toLocaleLowerCase();
      return (!query || searchable.includes(query))
        && (!userFilter || String(row.userId || row.userName) === userFilter)
        && (!farmFilter || String(row.farmId || row.farmName) === farmFilter)
        && (!cropFilter || row.cropType === cropFilter)
        && (!statusFilter || row.calculationStatus === statusFilter);
    });
  }, [fieldRows, searchTerm, userFilter, farmFilter, cropFilter, statusFilter]);

  const statistics = useMemo(() => ({
    total: fieldRows.length,
    visible: filteredRows.length,
    success: fieldRows.filter((row) => row.calculationStatus === "CALCULATION_SUCCEEDED").length,
    attention: fieldRows.filter((row) => ["CONFIGURATION_REQUIRED", "CALCULATION_FAILED", "CALCULATION_OUTDATED"].includes(row.calculationStatus)).length,
    automatic: fieldRows.filter((row) => row.autoCalcul).length,
  }), [fieldRows, filteredRows]);

  const clearFilters = () => {
    setSearchTerm("");
    setUserFilter("");
    setFarmFilter("");
    setCropFilter("");
    setStatusFilter("");
    setPage(0);
  };

  const columns = [
    {
      field: "userName", headerName: t("user"), minWidth: 210, flex: 1.2,
      renderCell: (params) => (
        <div className="field-user-cell">
          <span className="field-user-avatar">{params.value?.charAt(0)?.toUpperCase() || "?"}</span>
          <span><strong>{params.value}</strong><small>{params.row.userEmail || t("no_email", "Aucun e-mail")}</small></span>
        </div>
      ),
    },
    { field: "farmName", headerName: t("farm"), minWidth: 140, flex: 0.85 },
    { field: "fieldName", headerName: t("field"), minWidth: 140, flex: 0.85 },
    {
      field: "cropType", headerName: t("Crop"), minWidth: 170, flex: 1,
      renderCell: (params) => (
        <div className="field-two-lines"><strong>{params.value}</strong><small>{params.row.cropVariety}</small></div>
      ),
    },
    { field: "sensorCode", headerName: t("sensor"), minWidth: 105, flex: 0.65 },
    {
      field: "autoCalcul",
      headerName: t("auto_calcul_column", "Calcul auto"),
      width: 110,
      renderCell: (params) => (
        <Tooltip
          title={
            params.value ? t("auto_calcul_enabled") : t("auto_calcul_disabled")
          }
        >
          <Chip
            label={params.value ? t("enabled", "Activé") : t("disabled", "Désactivé")}
            size="small"
            color={params.value ? "success" : "default"}
            variant={params.value ? "filled" : "outlined"}
          />
        </Tooltip>
      ),
    },
    {
      field: "calculationStatus",
      headerName: t("calculation_status_column", "État du calcul"),
      minWidth: 205,
      flex: 1,
      renderCell: (params) => {
        const statusMeta = calculationStatusMeta[params.value];
        const meta = statusMeta
          ? { label: t(statusMeta.labelKey), color: statusMeta.color }
          : { label: params.value || t("unknown"), color: "default" };
        const messages = [...params.row.calculationReasons, ...params.row.calculationWarnings]
          .map((reason) => (calculationReasonKeys[reason] ? t(calculationReasonKeys[reason]) : reason));
        const kcMessage = getKcStatusMessage(params.row, t);
        return (
          <Tooltip title={[...messages, kcMessage].join(" • ")} arrow>
            <div className="field-status-cell">
              <Chip label={meta.label} size="small" color={meta.color} />
              <small>{messages[0] || kcMessage}</small>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "autoReport",
      headerName: t("auto_report_column", "Rapport auto"),
      width: 115,
      renderCell: (params) => (
        <Tooltip
          title={
            params.value ? t("auto_report_enabled") : t("auto_report_disabled")
          }
        >
          <Chip
            label={params.value ? t("enabled", "Activé") : t("disabled", "Désactivé")}
            size="small"
            color={params.value ? "success" : "default"}
            variant={params.value ? "filled" : "outlined"}
          />
        </Tooltip>
      ),
    },
    {
      field: "actions",
      width: 300,
      headerName: t("actions"),
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Box className="field-row-actions">
          <Tooltip title={t("open_field", "Ouvrir le champ")}><IconButton onClick={() => navigate(`/Fields/${params.row.uid}`)}><VisibilityIcon /></IconButton></Tooltip>
          <Tooltip title={t("sensor_history")}><span><IconButton disabled={params.row.sensorCode === "-"} onClick={() => goToHistory(params.row.sensorCode)}><HistoryIcon /></IconButton></span></Tooltip>
          <Tooltip title={t("report_history", "Historique des rapports")}><IconButton onClick={() => getSingleField(params.row.id)}><SummarizeIcon /></IconButton></Tooltip>
          <Tooltip title={t("view_last_report", "Voir le dernier rapport")}><IconButton onClick={() => handleViewReport(params.row.uid, params.row.id)}><PreviewIcon /></IconButton></Tooltip>
          <Tooltip title={t("recommendations")}><IconButton onClick={() => getSingleFieldRecmnds(params.row.id, params.row.userId)}><SmsIcon /></IconButton></Tooltip>
          <Tooltip title={t("run_calculation", "Lancer le calcul")}><IconButton onClick={() => calculSimulation(params.row.id, params.row.userId)}><CalculateIcon /></IconButton></Tooltip>
          <Tooltip title={t("automation", "Automatisation")}><IconButton onClick={() => openAutoSettingsModal(params.row)}><SettingsIcon /></IconButton></Tooltip>
        </Box>
      ),
    },
  ];

  const selectedIds = getSelectedFieldIds();
  const hasSelection = selectedIds.length > 0;

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const openAutoSettingsModal = (field) => {
    const findedField = fields.find((f) => f.uid === field.uid);

    if (!findedField) {
      console.warn("Field not found");
      return;
    }

    setSelectedField(findedField);
    setAutoCalcul(findedField.auto_calcul ?? false);
    setAutoRapport(findedField.auto_rapport ?? false);
    setAutoSatellite(findedField.auto_satellite ?? false);
    setModalOpen(true);
  };

  const closeAutoSettingsModal = () => {
    setModalOpen(false);
    setSelectedField(null);
  };

  const handleSaveAutoSettings = async () => {
    try {
      setSaving(true);
      const res = await api.post("/field/edit-auto-field", {
        field_uid: selectedField.uid,
        auto_calcul: autoCalcul,
        auto_rapport: autoRapport,
        auto_satellite: autoSatellite,
      });

      if (res.data.type === "success" || res.data.type === "info") {
        swal({
          title: res.data.type === "success" ? t("field_updated") : t("calculation_to_review", "Calcul à vérifier"),
          text: res.data.type === "success" ? t("settings_saved") : t("auto_calcul_no_data", "Le calcul automatique est activé, mais le premier calcul n'a produit aucune donnée."),
          icon: res.data.type === "success" ? "success" : "warning",
        });
        setRefreshFields(!refreshFields);
        closeAutoSettingsModal();
      } else {
        swal({
          icon: "error",
          title: t("error"),
          text: res.data.message || t("update_failed"),
        });
      }
    } catch (error) {
      console.error("Update failed:", error);
      const reasons = error.response?.data?.reasons;
      swal({
        icon: "error",
        title: t("error"),
        text: reasons?.length
          ? t("configuration_required_list", { list: reasons.join(", "), defaultValue: `Configuration requise : ${reasons.join(", ")}` })
          : t("failed_to_update_field"),
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Container className="admin-management-page">
        <section className="fields-admin-hero">
          <div>
            <span className="fields-admin-eyebrow">{t("agricultural_administration", "Administration agricole")}</span>
            <h1>{t("fields_and_calculations", "Champs et calculs")}</h1>
            <p>{t("fields_admin_subtitle", "Retrouvez rapidement un client, contrôlez la configuration et lancez les actions utiles.")}</p>
          </div>
          <div className="fields-admin-result-count"><strong>{statistics.visible}</strong><span>{t(statistics.visible > 1 ? "fields_displayed_plural" : "fields_displayed_singular", { defaultValue: `champ${statistics.visible > 1 ? "s" : ""} affiché${statistics.visible > 1 ? "s" : ""}` })}</span></div>
        </section>

        <section className="fields-admin-stats" aria-label={t("fields_summary", "Résumé des champs")}>
          <div><span>{t("total")}</span><strong>{statistics.total}</strong></div>
          <div><span>{t("calc_status_succeeded")}</span><strong className="is-success">{statistics.success}</strong></div>
          <div><span>{t("to_review", "À vérifier")}</span><strong className="is-warning">{statistics.attention}</strong></div>
          <div><span>{t("auto_calcul")}</span><strong>{statistics.automatic}</strong></div>
        </section>

        <section className="fields-admin-filters">
          <div className="fields-admin-filter-heading">
            <div><h2>{t("search_and_filter", "Rechercher et filtrer")}</h2><p>{t("fields_search_hint", "La recherche couvre le client, l’e-mail, la ferme, le champ, la culture et le capteur.")}</p></div>
            <Button variant="text" startIcon={<FilterAltOffIcon />} onClick={clearFilters}>{t("reset", "Réinitialiser")}</Button>
          </div>
          <div className="fields-admin-filter-grid">
            <label className="fields-admin-search"><span>{t("global_search", "Recherche globale")}</span><div><SearchIcon /><input type="search" placeholder={t("fields_search_placeholder", "Nom, e-mail, ferme, champ, culture, capteur…")} value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); setPage(0); }} /></div></label>
            <label><span>{t("user")}</span><select value={userFilter} onChange={(e) => { setUserFilter(e.target.value); setPage(0); }}><option value="">{t("all_users", "Tous les utilisateurs")}</option>{filterOptions.users.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</select></label>
            <label><span>{t("farm")}</span><select value={farmFilter} onChange={(e) => { setFarmFilter(e.target.value); setPage(0); }}><option value="">{t("all_farms", "Toutes les fermes")}</option>{filterOptions.farms.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</select></label>
            <label><span>{t("Crop")}</span><select value={cropFilter} onChange={(e) => { setCropFilter(e.target.value); setPage(0); }}><option value="">{t("all_crops", "Toutes les cultures")}</option>{filterOptions.crops.map((crop) => <option key={crop} value={crop}>{crop}</option>)}</select></label>
            <label><span>{t("calculation_status_column", "État du calcul")}</span><select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(0); }}><option value="">{t("all_statuses", "Tous les états")}</option>{Object.entries(calculationStatusMeta).map(([value, meta]) => <option key={value} value={value}>{t(meta.labelKey)}</option>)}</select></label>
          </div>
        </section>

        <section className={`fields-admin-bulk ${hasSelection ? "is-active" : ""}`}>
          <div><strong>{selectedIds.length || t("none", "Aucun")} {t(selectedIds.length > 1 ? "fields_selected_plural" : "fields_selected_singular", { defaultValue: `champ${selectedIds.length > 1 ? "s" : ""} sélectionné${selectedIds.length > 1 ? "s" : ""}` })}</strong><span>{t("fields_select_rows_hint", "Sélectionnez les lignes à traiter ensemble.")}</span></div>
          <div className="fields-admin-bulk-actions">
            <Tooltip
              title={
                !hasSelection ? t("select_fields_for_reports") : ""
              }
              arrow
            >
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={generateReport}
                  startIcon={<SummarizeIcon />}
                  disabled={!hasSelection || isGeneratingReport || isGeneratingCalcul}
                >
                  {t(isGeneratingReport ? "generating" : "generate_reports")}
                </Button>
              </span>
            </Tooltip>
            <Tooltip
              title={
                !hasSelection ? t("select_fields_for_calculs") : ""
              }
              arrow
            >
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CalculateIcon />}
                  onClick={handleGenerateCalcul}
                  disabled={!hasSelection || isGeneratingCalcul || isGeneratingReport}
                >
                  {t(isGeneratingCalcul ? "generating" : "generate_calcul")}
                </Button>
              </span>
            </Tooltip>
          </div>
        </section>
        {warningMessage && <Alert severity="warning" sx={{ mb: 2 }}>{warningMessage}</Alert>}
        <Card className="admin-data-card fields-admin-table-card">
          <DataGrid
            rows={filteredRows}
            columns={columns}
            loading={loading}
            checkboxSelection
            keepNonExistentRowsSelected
            onRowSelectionModelChange={(newSelection) =>
              setSelectionModel(newSelection)
            }
            disableRowSelectionOnClick
            paginationModel={{ pageSize, page }}
            onPaginationModelChange={(model) => {
              setPage(model.page);
              setPageSize(model.pageSize);
            }}
            pageSizeOptions={[5, 10, 20, 50]}
            rowHeight={68}
            columnHeaderHeight={56}
            autoHeight
            sx={{
              fontSize: "13px",
              border: 0,
              "& .MuiDataGrid-cell": { borderBottom: "1px solid #edf1f4" },
              "& .MuiDataGrid-columnHeaders": {
                borderBottom: "1px solid #dce5e1",
                backgroundColor: "#f1f7f4",
              },
              "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 700, color: "#24463a" },
              "& .MuiDataGrid-row:hover": { backgroundColor: "#f7fbf9" },
              "& .MuiDataGrid-row.Mui-selected": { backgroundColor: "#eaf6f0" },
            }}
          />
        </Card>
      </Container>
      <Modal size="lg" show={show} onHide={handleClose} dialogClassName="admin-management-modal">
        <Modal.Header className="d-flex flex-column">
          <Modal.Title>
            <h5>{t("field")}: {singleField.name}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table mb-0 text-center table-responsive-lg table-bordered">
            <thead className="bg-light">
              <tr>
                <th scope="col" className="border-0">{t("date")}</th>
                <th scope="col" className="border-0">{t("download")}</th>
                <th scope="col" className="border-0">{t("send")}</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((report) => (
                <tr key={report.id}>
                  <td>
                    {t("from")} {report.filename.slice(37, 47)} {t("to")}{" "}
                    {report.filename.slice(48, 58)}
                  </td>
                  <td>
                    <IconButton onClick={() => handleClick(report.filename)}>
                      <DownloadIcon />
                    </IconButton>
                  </td>
                  <td>
                    <IconButton
                      onClick={() => sendToUser(report.id, report.user_id)}
                    >
                      <SendIcon />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={showRecomnd} onHide={handleCloseRecomnd} dialogClassName="admin-management-modal">
        <Modal.Header className="d-flex flex-column">
          <Modal.Title>
            <h5>{t("recommendations")}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="admin-modal-panel">
            <h4 className="text-center">{t("title_recomnd")}</h4>
            <p className="text-center">{t("nb_recomnd")}</p>
            <div className="d-flex justify-content-center align-items-center flex-column">
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                name=""
                id=""
                cols="50"
                rows="5"
                className="form-control"
              />
              <Button
                className="my-2"
                variant="outline-primary"
                onClick={() => sendSMSToUser(getUserPhone(userId))}
              >
                <i className="material-icons">&#xe163;</i>
                {t("send_sms")}
              </Button>
            </div>
          </div>
          <Row className="d-flex justify-content-center align-items-center my-2">
            <Button onClick={() => setClicked(!clicked)}>{t("see_all")}</Button>
          </Row>
          {clicked && (
            <table className="table mb-0 text-center table-responsive-lg table-bordered">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">{t("date")}</th>
                  <th scope="col" className="border-0">{t("message")}</th>
                </tr>
              </thead>
              <tbody>
                {recommendations &&
                  recommendations.map((recomnd) => (
                    <tr key={recomnd.id}>
                      <td>
                        {new Date(recomnd.created_at)
                          .toISOString()
                          .slice(0, 10)}
                      </td>
                      <td>
                        <textarea
                          readOnly
                          className="form-control"
                          name=""
                          id=""
                          cols="40"
                          rows="5"
                          value={recomnd.message}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseRecomnd}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={openModal}
        onHide={handleCloseModal}
        className="custom-modal-height"
        dialogClassName="admin-management-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("calculation_results")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {result && (
            <Tabs
              defaultActiveKey="success"
              id="calcul-result-tabs"
              className="mb-3 w-100"
            >
              <Tab
                eventKey="success"
                title={`${t("success_status")} (${result.success.length})`}
                className="w-100"
              >
                <table className="table table-bordered table-hover table-sm">
                  <thead>
                    <tr>
                      <th>{t("field_name")}</th>
                      <th>{t("status")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {result.success.length > 0 ? (
                      result.success.map((item, index) => (
                        <tr key={`success-${index}`}>
                          <td>{item.fieldName}</td>
                          <td className="text-success fw-bold">
                            {t("success_status")}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" className="text-center">
                          {t("no_successful_calculations")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Tab>
              <Tab
                eventKey="failure"
                title={`${t("failed_status")} (${result.failure.length})`}
                className="w-100"
              >
                <table className="table table-bordered table-hover table-sm">
                  <thead>
                    <tr>
                      <th>{t("field_name")}</th>
                      <th>{t("status")}</th>
                      <th>{t("reason")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {result.failure.length > 0 ? (
                      result.failure.map((item, index) => (
                        <tr key={`fail-${index}`}>
                          <td>{item.fieldName}</td>
                          <td className="text-danger fw-bold">
                            {t("failed_status")}
                          </td>
                          <td>
                            <ul className="mb-0 ps-3">
                              {Array.isArray(item.details) &&
                              item.details.length > 0 ? (
                                item.details.map((d, i) =>
                                  Array.isArray(d.reasons) ? (
                                    d.reasons.map((reason, j) => (
                                      <li key={`${i}-${j}`}>{reason}</li>
                                    ))
                                  ) : typeof d === "string" ? (
                                    <li key={i}>{d}</li>
                                  ) : (
                                    <li key={i}>{t("unexpected_detail_format")}</li>
                                  )
                                )
                              ) : (
                                <li>{item.reason}</li>
                              )}
                            </ul>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          {t("no_failures")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Tab>
            </Tabs>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={reportModalOpen}
        onHide={handleCloseReportModal}
        className="custom-modal-height"
        dialogClassName="admin-management-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("report_generation_results")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reportGenerationResults && (
            <Tabs
              defaultActiveKey="success"
              id="report-generation-tabs"
              className="mb-3 w-100"
            >
              <Tab
                eventKey="success"
                title={`${t("success_status")} (${reportGenerationResults.success.length})`}
              >
                <table className="table table-bordered table-hover table-sm">
                  <thead>
                    <tr>
                      <th>{t("field_name")}</th>
                      <th>{t("status")}</th>
                      <th>{t("report")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportGenerationResults.success.length > 0 ? (
                      reportGenerationResults.success.map((item, index) => (
                        <tr key={`success-${index}`}>
                          <td>{item.fieldName}</td>
                          <td className="text-success fw-bold">{item.status}</td>
                          <td>
                            <a
                              href={`${process.env.REACT_APP_BASE_URL}/docs/${item.file}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {t("download")}
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          {t("no_successful_reports")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Tab>
              <Tab
                eventKey="failure"
                title={`${t("failed_status")} (${reportGenerationResults.failure.length})`}
              >
                <table className="table table-bordered table-hover table-sm">
                  <thead>
                    <tr>
                      <th>{t("field_name")}</th>
                      <th>{t("status")}</th>
                      <th>{t("reason")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportGenerationResults.failure.length > 0 ? (
                      reportGenerationResults.failure.map((item, index) => (
                        <tr key={`fail-${index}`}>
                          <td>{item.fieldName}</td>
                          <td className="text-danger fw-bold">{item.status}</td>
                          <td>
                            <ul className="mb-0 ps-3">
                              {Array.isArray(item.details) &&
                              item.details.length > 0 ? (
                                item.details.map((d, i) =>
                                  Array.isArray(d.reasons) ? (
                                    d.reasons.map((reason, j) => (
                                      <li key={`${i}-${j}`}>{reason}</li>
                                    ))
                                  ) : typeof d === "string" ? (
                                    <li key={i}>{d}</li>
                                  ) : (
                                    <li key={i}>{t("unexpected_detail_format")}</li>
                                  )
                                )
                              ) : (
                                <li>{item.reason}</li>
                              )}
                            </ul>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          {t("no_failures")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Tab>
            </Tabs>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseReportModal}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={modalOpen} onHide={closeAutoSettingsModal} centered dialogClassName="admin-management-modal">
        <Modal.Header closeButton>
          <Modal.Title>{t("auto_settings")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="admin-auto-settings">
          <Form className="d-flex justify-content-around mt-3">
            <Form.Check
              type="switch"
              id="autoCalculSwitch"
              label={t("auto_calcul")}
              checked={autoCalcul}
              onChange={(e) => setAutoCalcul(e.target.checked)}
            />
            <Form.Check
              type="switch"
              id="autoRapportSwitch"
              label={t("auto_report")}
              checked={autoRapport}
              onChange={(e) => setAutoRapport(e.target.checked)}
            />
              <Form.Check
    type="switch"
    id="autoSatelliteSwitch"
    label={t("auto_satellite_image")}
    checked={autoSatellite}
    onChange={(e) => setAutoSatellite(e.target.checked)}
  />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeAutoSettingsModal}>
            {t("cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveAutoSettings}
            disabled={saving}
          >
            {t(saving ? "saving" : "save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FieldsManagement;
